function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css, keyframes } from '@emotion/react';
import { forwardRef, useState } from 'react';
import { checkMarkUrl } from '@arc/frontend/ui-assets';
import { su, theme } from '@arc/frontend/ui-theme';
import { useOnChange } from '@arc/frontend/util-common';
const bounce = keyframes({
  '0%, 100%': {
    transform: 'scale(1, 1)'
  },
  '50%': {
    transform: 'scale(1.2, 1.2)'
  }
});
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "1j9pgm2",
    styles: "position:relative;display:inline-flex;align-items:center;justify-content:space-around;width:1.25rem;height:1.25rem"
  } : {
    name: "1v0yy8g-container",
    styles: "position:relative;display:inline-flex;align-items:center;justify-content:space-around;width:1.25rem;height:1.25rem;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  input: /*#__PURE__*/css({
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    opacity: '0',
    cursor: 'pointer',
    '&:disabled': process.env.NODE_ENV === "production" ? {
      name: "1sfig4b",
      styles: "cursor:not-allowed"
    } : {
      name: "kfrixr---disabled",
      styles: "cursor:not-allowed;label:--disabled;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    '&[readonly]': process.env.NODE_ENV === "production" ? {
      name: "1ll9bqd",
      styles: "cursor:default"
    } : {
      name: "1x82fqn---readonly-",
      styles: "cursor:default;label:--readonly-;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:input;"),
  visibleIndicator: /*#__PURE__*/css(su.roundedMd, {
    borderWidth: '2px',
    borderStyle: 'solid',
    width: '1.25rem',
    height: '1.25rem',
    pointerEvents: 'none',
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.palettes.primary.main,
    'input:checked + &': /*#__PURE__*/css({
      // Don't disable the border so that any `visibleIndicatorChildren`
      // elements do not change position between checked and unchecked.
      backgroundColor: theme.colors.palettes.primary.main,
      backgroundImage: `url("${checkMarkUrl}")`
    }, process.env.NODE_ENV === "production" ? "" : ";label:input-checked----;"),
    '&[data-doing-animation="true"]': {
      animation: `${bounce} 0.2s both`
    },
    'input:checked:disabled + &, input:checked[readonly] + &, input:checked[data-disabled="true"] + &': {
      backgroundColor: theme.colors.text.hint
    },
    'input[readonly] + &': {
      borderColor: theme.colors.text.hint
    },
    'input:disabled + &, input[data-disabled="true"] + &': {
      backgroundColor: theme.colors.input.disabledBackground,
      borderColor: theme.colors.text.hint
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:visibleIndicator;")
};
export const Checkbox = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function Checkbox({
  className,
  containerStyle,
  visibleIndicatorStyle,
  visibleIndicatorChildren,
  ...props
}, ref) {
  const [doingAnimation, setDoingAnimation] = useState(false);
  useOnChange(!!props.checked, () => {
    setDoingAnimation(true);
  });
  return <div css={[styles.container, containerStyle, process.env.NODE_ENV === "production" ? "" : ";label:Checkbox;"]} className={className}>
				<input css={styles.input} type="checkbox" ref={ref} {...props} />
				<div css={[styles.visibleIndicator, visibleIndicatorStyle, process.env.NODE_ENV === "production" ? "" : ";label:Checkbox;"]} data-doing-animation={doingAnimation} onAnimationEnd={() => setDoingAnimation(false)}>
					{visibleIndicatorChildren}
				</div>
			</div>;
});